/**
 * JWT Options
 */
export type JWTOpts = {
    exp: number;
    [key: string]: any;
};

/**
 * @class
 * JWT class helps us to decode and use JWT tokens
 */
export class JWT {
    /**
     * Decodes a JWT string into a JavaScript object
     *
     * @param {string} token - the token to be decoded
     *
     * @returns {JWTOpts}
     */
    static parseToken(token: string): JWTOpts {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    }

    /**
     * Decodes and returns the expiration of a JWT string
     *
     * @param {string} token - the token to be decoded
     *
     * @returns {number}
     */
    static getExpiration(token: string): number {
        const tokenObject = JWT.parseToken(token);
        const date = new Date(0);
        return date.setUTCSeconds(tokenObject.exp);
    }

    /**
     *
     * @param { String} token
     *
     * @returns {boolean}
     */
    static isExpired(token: string): boolean {
        const expiration = JWT.getExpiration(token);
        const now = new Date().valueOf();
        return expiration < now;
    }

    /**
     * Decodes and returns the email list of a JWT string
     *
     * @param {string} token - the token to be decoded
     *
     * @returns {string[] | null} - List of emails or null
     */
    static getUserEmails(token: string): string[] | null {
        try {
            return JWT.parseToken(token).emails || null;
        } catch (error) {
            return null;
        }
    }
}
